/**
 * This is a generic component that will render a timeline row without a fixed
 * prop structure, aside from its icon and icon color. Instead it prioritises
 * rendering its children as the main body of the timeline row. Rendering the
 * 'connector' line is based on a prop flag instead of calculating based on
 * index and total timeline count props (as in ./LogTimelineRow).
 */

import { colors } from '@lmc/common/constants'
import type React from 'react'
import styled from 'styled-components'

type TimelineRowProps = {
  children: React.ReactNode
  icon: { color?: string; url?: string }
  showConnector?: boolean
  style?: React.CSSProperties
  'data-testid'?: string
}

const TimelineRow = ({
  children,
  icon: { color = colors.darkblue, url },
  showConnector,
  style,
  'data-testid': dataTestId
}: TimelineRowProps) => (
  <Wrapper style={style} data-testid={dataTestId}>
    <LeftContainer>
      <IconContainer style={{ backgroundColor: color }}>
        <IconImg alt="" src={url} />
      </IconContainer>
      {showConnector && <Connector />}
    </LeftContainer>
    {children}
  </Wrapper>
)

export default TimelineRow

const Connector = styled.div`
  background: ${colors.grey};
  flex: 1;
  min-height: 10px;
  width: 4px;
`

const IconContainer = styled.div`
  align-items: center;
  border-radius: 44px;
  display: flex;
  height: 44px;
  justify-content: center;
  width: 44px;
`

const IconImg = styled.img`
  width: 18px;
`

const LeftContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-right: 15px;
  padding-top: 5px;
`

const Wrapper = styled.div`
  display: flex;
  margin-bottom: -5px;
`
